import { memo } from 'react'
import { isEqual } from 'lodash'
import { PageTitle } from 'app/components/common/PageTitle'
import R from 'app/assets/R'
import { useTranslation } from 'react-i18next'
import UnitManagementContainer from 'app/containers/HumanResources/UnitManagement'

const UnitManagementPageCpn = () => {
  const { t } = useTranslation()
  return (
    <>
      <PageTitle>{t(R.strings.unit_content_management)}</PageTitle>
      <UnitManagementContainer />
    </>
  )
}
const UnitManagementPage = memo(UnitManagementPageCpn, isEqual)

export default UnitManagementPage
